function isNotEmpty(str?: string): boolean {
  return (str?.trim().length ?? 0) > 0;
}

function isEmpty(str?: string): boolean {
  return !isNotEmpty(str);
}

export const StringFuncs = {
  isNotEmpty,
  isEmpty,
};
